import jwtDecode from 'jwt-decode';

export function ConvertBytesToImage(image) {
    if (image) {
        const byteCharacters = atob(decodeURIComponent(image));
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        //Convert byte data to Blob
        const blob = new Blob([byteArray], { type: 'image/png' });
        return (URL.createObjectURL(blob));
    }
    return undefined;
};

export function getBaseUrl() {
    if (window.location.hostname === 'localhost') {
        return "http://localhost:5205/api";
    }
    return "https://shop.coliza.in/api";
}



export const loadStorage = (key) => {
    try {
        const loadState = sessionStorage.getItem(key);
        if (loadState === null) {
            return undefined
        }
        return JSON.parse(loadState)
    }
    catch (err) {
        return undefined;
    }
}

export const saveStorage = (key, state) => {
    try {
        const loadState = JSON.stringify(state);
        sessionStorage.setItem(key, loadState);
    }
    catch (err) {
        // ignore
    }
}

export const clearItem = (key) => {
    try {
        sessionStorage.removeItem(key)
    }
    catch (err) {
        // ignore
    }
}


export function isTokenExpired() {
    const token = loadStorage("token");

    if (!token) {
        return true;
    }

    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    return decodedToken.exp < currentTime;
}
